import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, Redirect } from 'react-router-dom';
import keycloak from '../tools/keycloak';

const path2Menu = {
    "requestMain": ["requestMain"],
    "requestDocuments": ["requestDocuments"],
    "RequestEmails": ["RequestEmails"],
    "RequestActivities": ["RequestActivities"],
    "RequestHistory": ["RequestHistory"],
    "RequestSearchPage": ["RequestSearchPage"],
    "MyJobs": ["MyJobs"],
    "RequestResult": ["RequestResult"],
    "LogSearch": ["LogSearch"],
    "RequestPrices": ["RequestPrices"],
    "NewObjectPage": ["NewObjectPage"],
    "Division": ["Division"],
    "Vacations": ["Vacations"]
};

const NavMenu = (props) => {

    let [uname, setuname] = useState("");
    let location = useLocation();
    const requestId = sessionStorage.getItem("requestId");
    

    let ActiveMenuItem = item => {
        let routes = path2Menu[item];
        let currentRoute = location.pathname.split('/')[1];
        if (!routes || routes.filter(x => x === currentRoute).length === 0)
            return null;
        return "btn btn-primary";
    };

    const logout = () => {
        keycloak.logout();
    }

    keycloak.loadUserInfo().then(r => setuname(r.name));

    return (

        <div className="service-nav">
            <h5> {uname}</h5>
            <Link to='/MyJobs' className={ActiveMenuItem("MyJobs")}>Табло</Link>
            <Link to='/RequestSearchPage' className={ActiveMenuItem("RequestSearchPage")}>Търсене</Link>
            <Link to='/ObjectPage' className={ActiveMenuItem("NewObjectPage")}>Нова преписка</Link>
            {
                requestId ?
                    <>
                        <Link to='/requestMain' className={ActiveMenuItem("requestMain")}>Заявление</Link>
                        <Link to='/requestDocuments' className={ActiveMenuItem("requestDocuments")}>Документи</Link>
                        <Link to='/RequestEmails' className={ActiveMenuItem("RequestEmails")}>Комуникация</Link>
                        <Link to='/RequestHistory' className={ActiveMenuItem("RequestHistory")}>Дейности</Link>
                        <Link to='/RequestResult' className={ActiveMenuItem("RequestResult")}>Резултат</Link>
                        
                    </>
                    : null}


            <Link to='/DivisionPage' className={ActiveMenuItem("Division")}>Дирекции</Link>
            <Link to='/RequestPrices' className={ActiveMenuItem("RequestPrices")}>Цени</Link>
            <Link to='/Vacations' className={ActiveMenuItem("Vacations")}>Замествания</Link>
            <Link to='/LogSearch' className={ActiveMenuItem("LogSearch")}>Журнал</Link>
            <a onClick={() => logout()} href="#" alt="">Изход</a>
        </div >
    );

}

export default NavMenu;
